module.exports = __webpack_public_path__ + "static/img/slmPurpose4.f79719c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slmPurpose4.png
// module id = SnaQ
// module chunks = 2